import { useAtomValue } from "jotai";
import { useMemo } from "react";

import { appAtom } from "scmp-app/lib/app/atoms";

const excludeList = new Set(["AU", "HK", "ID", "IN", "MY", "PH", "SG", "VN"]);

export const useGeo = () => {
  const { navigatorInfo, navigatorInfoLoaded } = useAtomValue(appAtom);

  const shouldShowGDPRByGeo = useMemo(() => {
    if (!navigatorInfoLoaded) return false; // Still loading, do not show GDPR banner

    if (!navigatorInfo?.country) return true; // No geo data available, show GDPR banner by default

    // Check if the geo is not in the exclude list
    return !excludeList.has(navigatorInfo.country);
  }, [navigatorInfo, navigatorInfoLoaded]);

  return {
    isGeoLoaded: navigatorInfoLoaded,
    shouldShowGDPRByGeo,
  };
};
